import * as R from 'ramda';
import React, { useState } from 'react';
import UpdateUsersToIgnoreMutation from '../../../mutations/UpdateUsersToIgnoreMutation';

import {
  Button,
  Input,
  Spin
} from 'antd';

const useUsersToIgnoreEditor = (value) => {
  const [editedValue, setEditedValue] = useState(value);
  const [working, setWorking] = useState(false);
  const [error, setError] = useState(null);
  const [edited, setEdited] = useState(false);

  const onUpdateEditedValue = (e) => {
    setEditedValue(e.target.value);
    setEdited(true);
  };

  const onSave = () => {
    setError(null);
    setWorking(true);
    UpdateUsersToIgnoreMutation(editedValue, (ok, err) => {
      setWorking(false);
      if (err) setError(err);
      else setEdited(false);
    });
  };

  return {
    editedValue,
    onUpdateEditedValue,
    onSave,
    working,
    error,
    edited
  };
};

const UsersToIgnoreEditor = ({ value }) => {

  const {
    editedValue,
    working,
    onUpdateEditedValue,
    onSave,
    error,
    edited
  } = useUsersToIgnoreEditor(value);

  return (
    <div>
      <Input.TextArea
        value={editedValue}
        autoSize={{
          minRows: 10
        }}
        placeholder={'- adresse mail 1\n- adresse mail 2'}
        onChange={onUpdateEditedValue}
      />
      <br/>
      <br/>
      <Button
        onClick={onSave}
        disabled={working || !edited}
      >
        {'Enregistrer'}
        { working && <React.Fragment>&nbsp;<Spin size="small"/></React.Fragment>}
      </Button>
      {!R.isNil(error) ?
        error === 'yaml syntax' ? <span>{'Vérifiez la syntaxe. ("- mail@mail.fr")'}</span> : <span>Une erreur est survenue.</span> : <span></span>
      }
    </div>
  );
};

export default UsersToIgnoreEditor;
